import { useState, useEffect } from 'react'
import { MOBILE_BP } from '../styles/breakpoints'

/**
 * Tracks whether the viewport is at or below the mobile breakpoint, via
 * matchMedia (updates live on resize/orientation change, no polling).
 *
 * @returns {boolean}
 */
export function useIsMobile() {
  const query = `(max-width: ${MOBILE_BP}px)`
  const [isMobile, setIsMobile] = useState(() => window.matchMedia(query).matches)

  useEffect(() => {
    const mql = window.matchMedia(query)
    const handler = e => setIsMobile(e.matches)
    mql.addEventListener('change', handler)
    return () => mql.removeEventListener('change', handler)
  }, [query])

  return isMobile
}
